import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { BankEnum } from '@zaoblako/web/core/models/enums/bank.enum';
import { TenantService } from '@zaoblako/web/core/services/security/tenant.service';
import { WelcomeSystemImportSelectionTypeComponent } from '@zaoblako/web/shared/components/welcome-system/components/welcome-system-import-selection-type/welcome-system-import-selection-type.component';
import { WelcomeSystemInfoImportComponent } from '@zaoblako/web/shared/components/welcome-system/components/welcome-system-info-import/welcome-system-info-import.component';
import { WelcomeSystemSelectBankComponent } from '@zaoblako/web/shared/components/welcome-system/components/welcome-system-select-bank/welcome-system-select-bank.component';
import { WelcomeSystemStepEnum } from '@zaoblako/web/shared/components/welcome-system/enums/welcome-system-step.enum';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  standalone: true,
  selector: 'crm-welcome-system',
  templateUrl: './welcome-system.component.html',
  imports: [
    CommonModule,
    ButtonComponent,
    WelcomeSystemImportSelectionTypeComponent,
    WelcomeSystemInfoImportComponent,
    WelcomeSystemSelectBankComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WelcomeSystemComponent implements OnDestroy {
  public step: WelcomeSystemStepEnum = WelcomeSystemStepEnum.GREETINGS;
  public selectedBank: BankEnum;
  public showClose = true;

  public get WelcomeSystemStepEnum() {
    return WelcomeSystemStepEnum;
  }

  public constructor(
    private readonly ref: DynamicDialogRef,
    private readonly cdRef: ChangeDetectorRef,
    private readonly tenantService: TenantService
  ) {}

  public ngOnDestroy(): void {
    this.ref?.close();
  }

  public closeModal(isReminder = false) {
    if (!isReminder) {
      this.tenantService.disableWelcome().subscribe();
    }
    this.ref?.close();
  }

  public clickBack() {
    switch (this.step) {
      case WelcomeSystemStepEnum.IMPORT_SELECTION_BANK: {
        this.step = WelcomeSystemStepEnum.IMPORT_SELECTION_TYPE;
        break;
      }
      case WelcomeSystemStepEnum.IMPORT_FROM_BANK: {
        this.step = WelcomeSystemStepEnum.IMPORT_SELECTION_BANK;
        break;
      }
      case WelcomeSystemStepEnum.IMPORT_FROM_1C: {
        this.step = WelcomeSystemStepEnum.IMPORT_SELECTION_TYPE;
        break;
      }
    }
  }

  public changeStep(step: WelcomeSystemStepEnum) {
    this.step = step;
  }

  public selectBank(bank: BankEnum) {
    this.selectedBank = bank;
    this.step = WelcomeSystemStepEnum.IMPORT_FROM_BANK;
    this.cdRef.markForCheck();
  }
}
